import { Button, type ButtonProps } from '@music-vine/cadence/ui';
import { X } from '@music-vine/cadence/icons';
export const CloseButton = ({
  ...props
}: ButtonProps) => <Button size="icon" variant="transparent" {...props} data-sentry-element="Button" data-sentry-component="CloseButton" data-sentry-source-file="close-button.tsx">
    <X className="size-5" data-sentry-element="X" data-sentry-source-file="close-button.tsx" />
  </Button>;